import React from "react";
import ReactDOM from "react-dom";
import ReactAI from 'react-appinsights';
import { Router, Route, Link, IndexRoute, browserHistory } from "react-router";
import context from "./lib/context.js";

import App from "./view/app.jsx";
import Home from "./view/home.jsx";
import TCManagement from "./view/tc-management.jsx";
import TCManagement2 from "./view/tc-management2.jsx";
import PeopleTCSubmit from "./view/people-tc-submit.jsx";
import PayrollAdminTCSubmit from "./view/payrolladmin-tc-submit.jsx";
import TCEntry from "./view/tc-entry"; 
import FutureTCEntry from "./view/future-tc-entry";
import HistoryTCEntry from "./view/history-tc-entry";
import PayrollAdminHistoryTC from "./view/payrolladmin-history-tc.jsx";
import SupervisorHistoryTC from "./view/supervisor-history-tc.jsx";
import PeopleHistoryTC from "./view/people-history-tc.jsx";
import SupervisorTCDuration from "./view/supervisor-tc-duration.jsx";
import PayrollAdminTCDuration from "./view/payrolladmin-tc-duration.jsx";
import SupervisorTCClockEdit from "./view/supervisor-tc-clock-edit.jsx";
import PayrollAdminTCClockEdit from "./view/payrolladmin-tc-clock-edit.jsx";
import SupervisorTCApproval from "./view/supervisor-tc-approval.jsx";
import PayrollAdminTCApproval from "./view/payrolladmin-tc-approval.jsx";
import TCChanged from "./view/tc-changed.jsx";
import Delegates from "./view/delegates.jsx";
import TCVerify from "./view/tc-verify.jsx";
import TCVerify2 from "./view/tc-verify2.jsx";
import SupervisorReports from "./view/supervisor-reports.jsx";
import PayrollAdminReports from "./view/payrolladmin-reports.jsx";
import Login from "./view/login.jsx";
import MarketingAdmin from "./view/marketing-admin.jsx";
import ManageAnnouncement from "./view/marketing-admin/manage-announcement.jsx";
import AddAnnouncement from "./view/marketing-admin/add-announcement.jsx";
import ManagePages from "./view/marketing-admin/manage-pages.jsx";
import AddPage from "./view/marketing-admin/add-page.jsx";
import ManageNews from "./view/marketing-admin/manage-news.jsx";
import AddNews from "./view/marketing-admin/add-news.jsx";
import ManageForms from "./view/marketing-admin/manage-forms.jsx";
import AddForm from "./view/marketing-admin/add-form.jsx";
import PeoplePaystub from "./view/people-paystub.jsx";
import PeopleTaxDoc from "./view/people-taxdocs.jsx";
import ActivateUser from "./view/activate-user.jsx";
import PeopleAccrualHome from "./view/people-accrual-home.jsx";
import PeopleAccrualHomeOld from "./view/people-accrual-home-old.jsx";
import PeopleAccrualDisclaimer from "./view/people-accrual-disclaimer.jsx";
import SupervisorAccrualHome from "./view/supervisor-accrual-home.jsx";
import SupervisorAccrualHomeOld from "./view/supervisor-accrual-home-old.jsx";
import PRFMain from "./view/prf-main.jsx";
import RequestEntry from "./view/prf/request-entry.jsx";
import ApplicantLogMain from "./view/prf/applicant-log-main.jsx";
import ApplicantEntry from "./view/prf/applicant-entry.jsx";
import ForgotPassword from "./view/forgot-password.jsx";
import ResetPassword from "./view/change-password.jsx";
import ActivateInactiveUser from "./view/activate-inactive-user.jsx";
import PeopleDocument from "./view/people-document.jsx";
import { useRef } from "react";
import security, { securityRouteUpdateHandler } from "./lib/security.js";
import { forwardRef } from "react";
import popupManager from "./lib/auto-popup.js";

ReactAI.init({ instrumentationKey: context.aiKey() });

const RouterWrap = forwardRef((props, ref) => {
    console.log("register routes");
    if (!popupManager.isAutoPopupInit()) {
        const _appRoot = props.children;
        popupManager.registerAutoPopupPath(_appRoot.props.path, _appRoot.props.exact, _appRoot.props.strict);
        /** @type {string} */
        let root = _appRoot.props.path;
        if (!root.endsWith('/')) root += '/';
        for (const child of _appRoot.props.children) {
            
            /** @type {string} */            
            let path = child.props.path;
            if (path.startsWith('/')) path = path.substring(1);
            path = (root + path).substring((context.root() || "").length);

            popupManager.registerAutoPopupPath(path, child.props.exact, child.props.strict);
        }
    }

    return (
        <Router ref={ref} history={browserHistory} onUpdate={function () {
            console.log("ROUTE Changed", this.router.routes);
            securityRouteUpdateHandler(this.router.routes);
            if (this.router.location.pathname != null) {
                popupManager.checkForPopupAsync(this.router.location.pathname.substring((context.root() || "").length));
            }
            ReactAI.trackRouterChange();
        }}>{props.children}</Router>
    );
});

class ActionPortal extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const self = this;
        return (
            <RouterWrap ref="app_router" history={browserHistory} onUpdate={function () {
                console.log("ROUTE Changed");
                securityRouteUpdateHandler(this.router.routes);
                ReactAI.trackRouterChange();
            }}>
                <Route path={context.appRoot()} component={App}>
                    <Route path="payroll-admin/tc-management" component={TCManagement} role="payroll-admin" />
                    <Route path="payroll-admin/tc-management2" component={TCManagement2} role="payroll-admin" />
                    <Route path="payroll-admin/tc-duration/:timecardId" component={PayrollAdminTCDuration} role="payroll-admin" />
                    <Route path="payroll-admin/tc-clock-edit/:timecardId" component={PayrollAdminTCClockEdit} role="payroll-admin" />
                    <Route path="payroll-admin/history-tc" component={PayrollAdminHistoryTC} role="payroll-admin" />
                    <Route path="payroll-admin/tc-approval(/:submitted)(/:version)" component={PayrollAdminTCApproval} role="payroll-admin" />
                    <Route path="payroll-admin/tc-submit/:timecardId/:token" component={PayrollAdminTCSubmit} role="payroll-admin" />
                    <Route path="payroll-admin/reports" component={PayrollAdminReports} role="payroll-admin" />

                    <Route path="supervisor/tc-verify" component={TCVerify} role="supervisor" />
                    <Route path="supervisor/tc-verify2" component={TCVerify2} role="supervisor" />
                    <Route path="supervisor/tc-approval(/:submitted)(/:version)" component={SupervisorTCApproval} role="supervisor" />
                    <Route path="supervisor/tc-duration/:timecardId" component={SupervisorTCDuration} role="supervisor" />
                    <Route path="supervisor/tc-clock-edit/:timecardId" component={SupervisorTCClockEdit} role="supervisor" />
                    <Route path="supervisor/history-tc" component={SupervisorHistoryTC} role="supervisor" />
                    <Route path="supervisor/delegates" component={Delegates} role="supervisor" />
                    <Route path="supervisor/accrual-home" component={SupervisorAccrualHomeOld} role="supervisor" />
                    <Route path="supervisor/accrual-balance" component={SupervisorAccrualHome} role="supervisor" />
                    <Route path="supervisor/reports" component={SupervisorReports} role="supervisor" approot={context.appRoot()} />
                    <Route path="supervisor/prf-main" component={PRFMain} role="supervisor" />
                    <Route path="supervisor/request-entry/:requestId" component={RequestEntry} role="supervisor" />
                    <Route path="supervisor/request-copy/:requestId" component={RequestEntry} role="supervisor" />
                    <Route path="supervisor/applicant-log-main/:requestId" component={ApplicantLogMain} role="supervisor" />
                    <Route path="supervisor/applicant-entry/:requestId/:applicantId" component={ApplicantEntry} role="supervisor" />
                    <Route path="supervisor/reports" component={SupervisorReports} role="supervisor" approot={context.appRoot()} />

                    <Route path="people/tc-entry" component={TCEntry} role="people" />
                    <Route path="people/future-tc-entry" component={FutureTCEntry} role="people" />
                    <Route path="people/history-tc-entry/:timecardId" component={HistoryTCEntry} role="people" />
                    <Route path="people/tc-submit/:timecardId/:token" component={PeopleTCSubmit} role="people" />
                    <Route path="people/tc-submit-complete/:timecardId/:token" component={PeopleTCSubmit} role="people" />
                    
                    <Route path="people/history-tc" component={PeopleHistoryTC} role="people" />
                    <Route path="people/tc-changed" component={TCChanged} role="people" />
                    <Route path="people/paystub" component={PeoplePaystub} role="people" />
                    <Route path="people/taxdocs" component={PeopleTaxDoc} role="people" />
                    <Route path="people/accrual-home" component={PeopleAccrualHomeOld} role="people" />
                    <Route path="people/accrual-balance" component={PeopleAccrualHome} role="people" />
                    <Route path="people/accrual-balance/create" component={PeopleAccrualHome} role="people" action="create" />
                    <Route path="people/accrual-disclaimer" component={PeopleAccrualDisclaimer} role="people" />
                    <Route path="people/document" component={PeopleDocument} role="people" />

                    <Route path="login" component={Login} menuVisibility='hide' />
                    <Route path="home" component={Home} security={[{ action: "demand", claims: "abcd" }]} />
                    <Route path="marketing-admin" component={MarketingAdmin} />
                    <Route path="manage-announcement" component={ManageAnnouncement} />
                    <Route path="add-announcement/:announcementId" component={AddAnnouncement} />
                    <Route path="manage-pages" component={ManagePages} />
                    <Route path="add-page/:id" component={AddPage} />
                    <Route path="manage-news" component={ManageNews} />
                    <Route path="add-news/:id" component={AddNews} />
                    <Route path="manage-forms" component={ManageForms} />
                    <Route path="add-form/:id" component={AddForm} />
                    <Route path="activate-user/:token" component={ActivateUser} menuVisibility='hide' />
                    <Route path="forgot-password" component={ForgotPassword} menuVisibility='hide' />
                    <Route path="reset-password/:token" component={ResetPassword} menuVisibility='hide' />
                    <Route path="activate-inactive-user/:token" component={ActivateInactiveUser} menuVisibility='hide' />

                    <Route path="hr/prf-main" component={PRFMain} role="hr" />
                    <Route path="hr/request-entry/:requestId" component={RequestEntry} role="hr" />
                    <Route path="hr/request-approve/:requestId" component={RequestEntry} role="hr" />
                    <Route path="hr/request-reject/:requestId" component={RequestEntry} role="hr" />
                    <Route path="hr/applicant-log-main/:requestId" component={ApplicantLogMain} role="hr" />
                    <Route path="hr/applicant-entry/:requestId/:applicantId" component={ApplicantEntry} role="hr" />

                    <Route path="exec/prf-main" component={PRFMain} role="exec" />
                    <Route path="exec/request-entry/:requestId" component={RequestEntry} role="exec" />
                    <Route path="exec/request-approve/:requestId" component={RequestEntry} role="exec" />
                    <Route path="exec/request-reject/:requestId" component={RequestEntry} role="exec" />
                    <Route path="exec/applicant-log-main/:requestId" component={ApplicantLogMain} role="exec" />
                    <Route path="exec/applicant-entry/:requestId/:applicantId" component={ApplicantEntry} role="exec" />

                    
                </Route>
            </RouterWrap>

        );
    }
}



security.getTrackedHrefAsync()
    .then(r => {
        context.trackedHref(r.data || []);
        ReactDOM.render(<ActionPortal />, document.getElementById("bodyWrapper"));
    });

/*

*/